import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useForm, useFormState } from 'react-final-form';
import { FormInput } from '../../../../../../components/atoms/Fields/Input';
import Typography from '../../../../../../components/styles/Typography';
import ProductsTable from '../../OrderForm/ProductsTable';
import { ProductsTableItem } from '../../OrderForm/types';
import { OrderFormValues } from '../../../types';
import InlineProductSearch from './InlineProductSearch';
import {
  StyledStepColumn,
  StyledStepCard,
  StyledStepCardTitle,
  StyledStepHint,
  StyledFieldHint,
  StyledEmptyHint,
} from '../styles';

const StepProducts: React.FC = () => {
  const { mutators } = useForm();
  const {
    values: { entity, currency, products = [] },
  } = useFormState<OrderFormValues>();

  const handleProductAdd = (newProduct: ProductsTableItem) =>
    mutators.push('products', newProduct);

  return (
    <StyledStepColumn>
      <StyledStepCard>
        <StyledStepCardTitle>
          <FormattedMessage id='orders.products' defaultMessage='Products' />
        </StyledStepCardTitle>
        <StyledStepHint>
          <FormattedMessage
            id='orderWizard.productsOptional'
            defaultMessage='Products are optional — add items from your warehouse, or enter the order value manually below.'
          />
        </StyledStepHint>
        {!entity || !currency ? (
          <StyledEmptyHint>
            <FormattedMessage
              id='orderWizard.chooseStoreFirst'
              defaultMessage='Choose a store in step 1 to search its products.'
            />
          </StyledEmptyHint>
        ) : (
          <InlineProductSearch
            currency={currency}
            entityId={entity}
            productsInOrder={products}
            onProductAdd={handleProductAdd}
          />
        )}
        {products.length > 0 ? (
          <ProductsTable data={products} {...{ currency }} />
        ) : (
          <Typography variant='body' textAlign='center'>
            <FormattedMessage
              id='products.noProductsAdded'
              defaultMessage='No products added'
            />
          </Typography>
        )}
      </StyledStepCard>
      <StyledStepCard>
        <StyledStepCardTitle>
          <FormattedMessage id='products.total' defaultMessage='Total' />
        </StyledStepCardTitle>
        <FormInput
          name='total'
          suffixComponent={
            <Typography variant='captionBold'>{currency}</Typography>
          }
          type='number'
          min={0}
          step={1}
        />
        <StyledFieldHint>
          <FormattedMessage
            id='orderWizard.orderValueHint'
            defaultMessage='The amount your customer will be charged. Pre-filled from the products total — edit it to override.'
          />
        </StyledFieldHint>
      </StyledStepCard>
    </StyledStepColumn>
  );
};

export default StepProducts;
